export type SmsDelivery = {
  id: string;
  provider: string;
  status: string;
  purpose: string;
  provider_ref?: string | null;
  provider_message_id?: string | null;
  submitted_at?: string | null;
  delivered_at?: string | null;
  failed_at?: string | null;
  created_at?: string | null;
  failure_reason?: string | null;
};

const isAuthenticationPurpose = (purpose: string) => {
  const normalized = purpose.toLowerCase().replace(/_/g, '-');
  return (
    normalized.includes('phone-otp') ||
    normalized.includes('migration-recovery') ||
    normalized.includes('rica-contact-otp') ||
    normalized.includes('verification') ||
    normalized.includes('password-reset') ||
    normalized.includes('username-recovery')
  );
};

const eventTime = (message: SmsDelivery) =>
  Date.parse(
    message.delivered_at ||
      message.failed_at ||
      message.submitted_at ||
      message.created_at ||
      '',
  ) || 0;

const isBlistFailure = (message: SmsDelivery) =>
  message.status.toUpperCase() === 'FAILED' &&
  /\bBLIST\b|BLACKLIST/i.test(message.failure_reason || '');

export function findCurrentSmsPortalBlist(messages: SmsDelivery[]) {
  const authenticationDeliveries = messages
    .filter(
      (message) =>
        message.provider.toUpperCase().replace(/[^A-Z]/g, '') === 'SMSPORTAL' &&
        isAuthenticationPurpose(message.purpose),
    )
    .sort((left, right) => eventTime(right) - eventTime(left));

  const latestBlist = authenticationDeliveries.find(isBlistFailure);

  if (!latestBlist) {
    return null;
  }

  const deliveredAfterBlist = authenticationDeliveries.some(
    (message) =>
      message.status.toUpperCase() === 'DELIVERED' &&
      eventTime(message) > eventTime(latestBlist),
  );

  return deliveredAfterBlist ? null : latestBlist;
}
